<template>
  <base-layout show-back-btn="true" page-default-back-link="/" show-info="true">
    <ion-text color="primary" class="ion-text-center title-headline">
      <h1>Søgning</h1>
    </ion-text>

    <ion-item class="result-search">
      <ion-icon :icon="icons.search" slot="start"></ion-icon>
      <ion-input
        type="tel"
        v-model="postnr"
        clear-on-edit="true"
        required
        @input="clearError()"
        v-on:keyup.enter="newSearch()"
      ></ion-input>
      <ion-button
        @click="newSearch()"
        slot="end"
        size="medium"
        color="white"
        shape="round"
      >
        <ion-icon
          :icon="icons.forward"
          slot="icon-only"
          color="primary"
        ></ion-icon>
      </ion-button>
    </ion-item>

    <ion-item-divider v-if="errorMessage.length > 0">
      <ion-label>
        {{ errorMessage }}
      </ion-label>
    </ion-item-divider>
    <ion-item class="" @click="showFilters = !showFilters">
      <ion-icon :icon="icons.filter" slot="start"></ion-icon>
      <ion-input readonly> Filtre </ion-input>
      <ion-icon :icon="chevron" class="chevron-icon"></ion-icon>
    </ion-item>
    <div class="filter-dropdown" v-if="showFilters">
      <ion-item>
        <ion-label for="Hund">
          <img class="filter-icon" :src="dogImgUrl" alt="" />
          <ion-text>Hund</ion-text>
        </ion-label>
        <ion-checkbox
          name="Hund"
          color="primary"
          v-model="filters.Hund"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label for="Aspirant">
          <img class="filter-icon" :src="aspImgUrl" alt="" />
          <ion-text>Aspirant</ion-text>
        </ion-label>
        <ion-checkbox
          name="Aspirant"
          color="primary"
          v-model="filters.Aspirant"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label for="Kommunal">
          <img class="filter-icon" :src="townImgUrl" alt="" />
          <ion-text>Kommunal</ion-text>
        </ion-label>
        <ion-checkbox
          name="Kommunal"
          color="primary"
          v-model="filters.Kommunal"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label for="Skytte">
          <img class="filter-icon" :src="skytteImgUrl" alt="" />
          <ion-text>Skytte</ion-text>
        </ion-label>
        <ion-checkbox
          name="Skytte"
          color="primary"
          v-model="filters.Skytte"
        ></ion-checkbox>
      </ion-item>
      <ion-button fill="clear" @click="resetFilters" class="asLink">
        <ion-icon
          :icon="icons.close"
          slot="start"
          class="reset-icon"
        ></ion-icon>
        Nulstil
      </ion-button>
    </div>
    <ion-item v-if="warningMessage" color="warning">
      <ion-label>{{ warningMessage }}</ion-label>
    </ion-item>
    <div class="result-content">
      <div v-if="!listLoaded" class="spinner">
        <ion-spinner color="primary" name="bubbles"></ion-spinner>
      </div>
      <div v-else>
        <div v-if="postData && filteredList.length > 0">
          <div class="result-top">
            <ion-text>
              <h3>Resultat ({{ filteredList.length }})</h3>
            </ion-text>
            <ion-text>
              <ion-label v-if="postData">
                <ion-text color="primary">{{ postData.nr }}</ion-text> ({{
                  postData.navn
                }})
              </ion-label>
            </ion-text>
          </div>
          <ion-list>
            <person
              v-for="(person, index) in filteredList"
              :key="person.Id || person.Initialer || index"
              :person="person"
            ></person>
          </ion-list>
        </div>
        <div v-else>
          <ion-card>
            <ion-item>
              <ion-card-content>
                <ion-text class="ion-text-center">
                  <ion-label>{{ noResultText }}</ion-label>
                </ion-text>
              </ion-card-content>
            </ion-item>
          </ion-card>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapGetters } from "vuex";
import {
  informationCircle,
  search,
  close,
  filter,
  chevronDown,
  chevronUp,
  arrowForwardCircleOutline,
} from "ionicons/icons";
import {
  IonList,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonInput,
  IonIcon,
  IonButton,
  IonText,
  IonSpinner,
  IonCheckbox,
  IonItemDivider,
  IonCard,
  IonCardContent,
} from "@ionic/vue";
import person from "../components/app/Person";
import zipData from "../../public/assets/data/zipcodes.json";

export default {
  components: {
    IonList,
    IonItem,
    IonItemGroup,
    IonLabel,
    IonInput,
    IonIcon,
    IonButton,
    IonText,
    person,
    IonSpinner,
    IonCheckbox,
    IonItemDivider,
    IonCard,
    IonCardContent,
  },
  computed: {
    ...mapGetters(["data"]),
    chevron() {
      return this.showFilters ? this.icons.up : this.icons.down;
    },
    filteredList() {
      var app = this;
      this.listLoaded = false;

      setTimeout(() => {
        app.listLoaded = true;
      }, 200);
      const teknikere = (this.data || []).filter(
        (t) =>
          (t.Titel || "").toString().toLowerCase().trim() === "servicetekniker"
      );
      if (this.postData && teknikere.length > 0) {
        for (let index = 0; index < teknikere.length; index++) {
          const element = teknikere[index];
          element.distance = this.distance(
            element.y,
            element.x,
            this.postData.lat,
            this.postData.lng
          ).toFixed(0);
        }

        var list = teknikere;

        if (Object.values(this.filters).includes(true)) {
          list = teknikere.filter(function(item) {
            for (var key in app.filters) {
              if (item[key] === "x" && app.filters[key]) return true;
            }
            return false;
          });
        }

        return list.sort((a, b) => b.distance - a.distance).reverse();
      }
      return [];
    },
    noResultText() {
      if (!this.postData) return "Postnummer findes ikke";
      return "Der blev ikke fundet nogen serviceteknikere";
    },
    dogImgUrl() {
      return require("../../public/assets/icon/dog.png");
    },
    aspImgUrl() {
      return require("../../public/assets/icon/aspirant.png");
    },
    townImgUrl() {
      return require("../../public/assets/icon/town.png");
    },
    skytteImgUrl() {
      return require("../../public/assets/icon/skytte.png");
    },
    warningMessage() {
      // return this.postnr == "6950"
      //   ? "Der er i øjeblikket problemer med at udregne distancen til 6950 Ringkøbing - Brug 6940 Lem istedet."
      //   : "";
      return "";
    },
  },
  data() {
    return {
      icons: {
        info: informationCircle,
        search: search,
        close: close,
        filter: filter,
        down: chevronDown,
        up: chevronUp,
        forward: arrowForwardCircleOutline,
      },
      listLoaded: false,
      showFilters: false,
      postnr: this.$route.query.postnr,
      postData: null,
      errorMessage: "",
      filters: {
        Hund: false,
        Aspirant: false,
        Kommunal: false,
        Skytte: false,
      },
    };
  },
  mounted() {
    this.getPostData();
  },
  methods: {
    resetFilters() {
      for (var i in this.filters) {
        this.filters[i] = false;
      }
    },
    clearError() {
      this.errorMessage = "";
    },
    // Haversine, afstand i km (jordradius 6371 km)
    distance(lat1, lon1, lat2, lon2) {
      const rad = Math.PI / 180;
      const dLat = (lat2 - lat1) * rad;
      const dLon = (lon2 - lon1) * rad;
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLon / 2) ** 2;
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    },
    getPostData(postData = null) {
      var app = this;
      this.listLoaded = false;

      setTimeout(() => {
        if (!postData) {
          postData = zipData.find((x) => x.nr == app.postnr);
        }
        if (postData != null) {
          app.postData = postData;
        }
        app.listLoaded = true;
      }, 500);
    },
    newSearch() {
      if (this.postnr.length == 4) {
        var dataPostnr = zipData.find((x) => x.nr == this.postnr);
        if (dataPostnr) {
          this.getPostData(dataPostnr);
        } else {
          this.errorMessage = "Postnummer findes ikke";
        }
      } else {
        this.errorMessage = "Udfyld korrekt postnummer";
      }
    },
  },
};
</script>
